/*
 * tp-cart-sync.js
 * ------------------------------------------------------------
 * Hält die Warenkorb-Anzeige (Header-Zähler, Drawer) deckungsgleich mit dem
 * echten Warenkorb – auch dann, wenn der Browser eine Seite nicht neu rendert.
 *
 * Ursache des früheren Fehlers: Zähler und Drawer werden vom Server in die
 * Seite geschrieben und danach nur per JS nachgeführt. Beim Zurück-Button
 * holt der Browser die Seite aus dem bfcache (DOM-Momentaufnahme) oder dem
 * HTTP-Cache – ohne neuen Server-Render. Dort stand dann der Warenkorb von
 * vor dem Hinzufügen.
 *
 * Lösung: theme.liquid legt den gerenderten Stand als Fingerabdruck ab
 * (window.tpCartFingerprint). Beim Wiederherstellen einer Seite (pageshow aus
 * bfcache oder Navigationstyp back_forward) und wenn ein Tab wieder sichtbar
 * wird (Änderung in einem anderen Tab) wird /cart.js gelesen und verglichen.
 * Nur bei Abweichung wird neu gerendert – ohne Flackern bei unverändertem Stand.
 *
 * API (window.tpCartSync):
 *   refresh()  – Zähler und Drawer vom Server neu holen (nach Hinzufügen)
 *   remember(cart) – Stand nach einer eigenen Änderung merken (cart.js)
 */
(function () {
  if (window.tpCartSync) return;

  var VISIBLE_MIN_INTERVAL = 3000;

  var rendered = typeof window.tpCartFingerprint === 'string' ? window.tpCartFingerprint : null;
  var generation = 0;
  var lastVisibleCheck = 0;

  function fingerprint(cart) {
    return (cart.items || [])
      .map(function (item) { return item.key + ':' + item.quantity; })
      .join(',');
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function getJSON(url) {
    return fetch(url, { cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.json();
    });
  }

  function loadCart() {
    return getJSON(root() + 'cart.js');
  }

  function sectionIds() {
    var ids = ['cart-icon-bubble'];
    if (document.querySelector('cart-drawer')) ids.push('cart-drawer');
    return ids;
  }

  function loadSections() {
    return getJSON(window.location.pathname + '?sections=' + sectionIds().join(','));
  }

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function applySections(sections) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var freshBubble = parse(sections['cart-icon-bubble']);
      var inner = freshBubble.querySelector('.shopify-section');
      bubble.innerHTML = inner ? inner.innerHTML : freshBubble.body.innerHTML;
    }

    var drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      var freshDrawer = parse(sections['cart-drawer']).querySelector('cart-drawer');
      if (freshDrawer) {
        drawer.innerHTML = freshDrawer.innerHTML;
        // Nur is-empty übernehmen: active/animate gehören dem geöffneten Zustand
        drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
      }
    }
  }

  function refresh() {
    var gen = ++generation;
    return Promise.all([loadCart(), loadSections()]).then(function (results) {
      if (gen !== generation) return;
      applySections(results[1]);
      rendered = fingerprint(results[0]);
    });
  }

  function check() {
    var gen = ++generation;
    return loadCart()
      .then(function (cart) {
        if (gen !== generation) return;
        if (rendered !== null && fingerprint(cart) === rendered) return;

        // Die Warenkorbseite besteht komplett aus Server-Markup (leer/gefüllt,
        // Summen, Hinweise) – dort ist ein neuer Abruf der Seite der Weg.
        if (document.getElementById('main-cart-items')) {
          window.location.reload();
          return;
        }

        return loadSections().then(function (sections) {
          if (gen !== generation) return;
          applySections(sections);
          rendered = fingerprint(cart);
        });
      })
      .catch(function () {});
  }

  function remember(cart) {
    generation++;
    if (cart && cart.items) rendered = fingerprint(cart);
  }

  function isHistoryNavigation() {
    var entries = window.performance && performance.getEntriesByType
      ? performance.getEntriesByType('navigation')
      : [];
    return !!entries[0] && entries[0].type === 'back_forward';
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      // Aus dem bfcache: ein beim Verlassen offener Drawer soll nicht offen bleiben
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.classList.contains('active') && typeof drawer.close === 'function') drawer.close();
    }
    if (event.persisted || isHistoryNavigation()) check();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    var now = Date.now();
    if (now - lastVisibleCheck < VISIBLE_MIN_INTERVAL) return;
    lastVisibleCheck = now;
    check();
  });

  window.tpCartSync = { refresh: refresh, remember: remember, check: check };
})();
